import { Route, Routes } from 'react-router-dom'

import { RequireAuth } from './context/Auth/Auth'

import {
  LoginPage,
  ForgotPasswordPage,
  SignUpPage,
  HomePage,
  DashboardPage,
  MyEventPage,
  CreateEventPage,
  EventDetailsPage,
  EventSettingsPage,
  WaitlistPage,
  SeatMapPage,
  OffersPage,
  OrdersPage,
  AllOrdersPage,
  PrimaryTicketsPage,
  ResaleTicketsPage,
  DailyTicketCountsPage,
  ContactAttendeesPage,
  GuestListPage,
  ViewGuestListPage,
  GuestInformationPage,
  TrackingLinksPage,
  AttendeesPage,
  SettingsPage,
  OrganizationInfoPage,
  OrganizationSettingsPage,
  TeamManagementPage,
  SecurityPage,
  AccountInformationPage,
  PayoutsPage,
  TaxStatusPage,
  RegisterPage,
  MyPackagePage,
  PackageDashboardPage,
  PackageDetailsPage,
  PackageSeatmapPage,
  AssignPackagesPage,
  PackageHoldersPage,
  GroupTicketsPage,
  AttendanceSummaryPage,
  AccessControlPage,
  AccessControlSummaryV2Page,
  EventSalesAndAttendancePage,
  CompIntelligencePage,
  AnalyticsPage,
  SearchOrdersPage,
  TicketExchangePage,
  MyFlexPackPage,
  SeasonPackagesPage,
  AccessPassesPage,
  AccessPassHoldersReportPage,
  GroupPurchasesPage,
  ReportsPage,
  ReportingPage,
  PromoterSalesReportsPage,
  SeasonSummaryPage,
  DeferredRevenuePage,
  FlexPackDeferredRevenuePage,
  DailyTicketsCountReportPage,
  SettlementReportPage,
  FlexPackDetailsPage,
  FlexPacksPage,
  FlexPackDashboardPage,
  AssignFlexPackagesPage,
  FlexPackHoldersPage,
  TerminalsPage,
  ScannersPage,
  CustomFeesPage,
  BuyerTypesPage,
  MarketingTrackingPage,
  EmailTemplatesPage,
  MarketplacePage,
  MarketplaceItemsPage,
  MarketplaceItemFormPage,
  MarketplaceCategoriesPage,
  MarketplaceLocationsPage,
  MarketplaceModifiersPage,
  MarketplaceImportExportPage,
  FulfillmentBoardPage,
  MarketplaceOrdersPage,
  DonationsPage,
  TimeStampReportPage,
  SalesSummaryPage,
  PaymentListingsPage,
  PaymentListingsV4Page,
  SeasonReportPage,
  CustomFeeReportPage,
  HensonFundReportPage,
  PaymentMethodTypeReportPage,
  PayoutsReportPage,
  PaymentPlansReportPage,
  PackagesReportPage,
  FlexPackageSalesSummaryPage,
  SalesReceivablesByCategoryPage,
  BuyerTypesReportPage,
  AgedReceivablesPage,
  ARAgingSummaryPage,
  ARAgingDetailsPage,
  UserBalanceTotalsPage,
  DailySettlementPage,
  SummaryByPaymentMethodPage,
  AccountingDashboardPage,
  AccountingReportPage,
  OrganizationDashboardPage,
  ClientReportPage,
  PromoCodesPage,
  PromoEmailsPage,
  FundraisersPage,
  ClubSeatPage,
  ScanChartPage,
  TicketMatrixPage,
  InvoicePage,
  DepositsPage,
  AssignInventoryPage,
  ReportBuilderPage,
  YOYDifferenceReportPage,
  SalesVelocityPage,
  PricingLevelPerformancePage,
  AttendanceIntelligencePage,
  GeographicSalesIntelligencePage,
  WeatherEventAnalyticsPage,
  FnbAnalyticsPage,
  FnbEodReportPage,
  RevenueInsightsPage,
  InsightsDashboardPage,
  DynamicPricingPage,
} from './pages'

import { ScrollToTop } from './components'

/**
 * @description Handle all the routes
 */

const Router = () => {
  return (
    <ScrollToTop>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login/forgot-password" element={<ForgotPasswordPage />} />
        {[
          '/signup',
          '/signup/organization-information',
          '/signup/team-management',
          '/signup/payment-information',
          'signup/tax-status',
        ].map((path) => (
          <Route key={path} path={path} element={<SignUpPage />} />
        ))}
        <Route
          path="/package/:uuid"
          element={
            <RequireAuth>
              <MyPackagePage />
            </RequireAuth>
          }
        >
          <Route index element={<PackageDashboardPage />} />
          <Route path="package-details" element={<PackageDetailsPage />} />
          {['seatmap', 'seatmap/assign'].map((path) => (
            <Route key={path} path={path} element={<PackageSeatmapPage />} />
          ))}
          {['assign-packages', 'assign-packages/fan/:id/profile'].map(
            (path) => (
              <Route key={path} path={path} element={<AssignPackagesPage />} />
            )
          )}
          {['package-holders', 'package-holders/fan/:id/profile'].map(
            (path) => (
              <Route key={path} path={path} element={<PackageHoldersPage />} />
            )
          )}
        </Route>
        <Route
          path="/event/:uuid"
          element={
            <RequireAuth>
              <MyEventPage />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="event-details" element={<EventDetailsPage />} />
          <Route path="event-settings" element={<EventSettingsPage />} />
          <Route path="waitlist" element={<WaitlistPage />} />
          <Route
            path="invoice/:orderId/:stripeInvoiceId?"
            element={<InvoicePage />}
          />
          {['seatmap', 'seatmap/assign', 'seatmap/assign/:id'].map((path) => (
            <Route key={path} path={path} element={<SeatMapPage />} />
          ))}
          {['offers', 'offers/create', 'offers/edit'].map((path) => (
            <Route key={path} path={path} element={<OffersPage />} />
          ))}
          {['dynamic-pricing', 'dynamic-pricing/edit'].map((path) => (
            <Route key={path} path={path} element={<DynamicPricingPage />} />
          ))}
          <Route path="orders" element={<OrdersPage />}>
            <Route index element={<AllOrdersPage />} />
          </Route>
          <Route path="guest-list" element={<GuestListPage />}>
            <Route index element={<ViewGuestListPage />} />
            <Route path="add" element={<GuestInformationPage />} />
          </Route>
          <Route path="attendees" element={<AttendeesPage />} />
          <Route path="primary-tickets" element={<PrimaryTicketsPage />} />
          <Route path="resale-tickets" element={<ResaleTicketsPage />} />
          {[
            'daily-ticket-counts',
            'daily-ticket-counts/add',
            'daily-ticket-counts/edit',
          ].map((path) => (
            <Route key={path} path={path} element={<DailyTicketCountsPage />} />
          ))}
          {[
            'contact-attendees',
            'contact-attendees/add',
            'contact-attendees/edit',
          ].map((path) => (
            <Route key={path} path={path} element={<ContactAttendeesPage />} />
          ))}
          {['tracking-links', 'tracking-links/add'].map((path) => (
            <Route key={path} path={path} element={<TrackingLinksPage />} />
          ))}
          <Route path={'assign-tickets'} element={<GroupTicketsPage />} />
        </Route>
        <Route
          path="attendance-summary"
          element={
            <RequireAuth>
              <AttendanceSummaryPage />
            </RequireAuth>
          }
        />
        <Route
          path="access-control-summary"
          element={
            <RequireAuth>
              <AccessControlPage />
            </RequireAuth>
          }
        />
        <Route
          path="access-control-summary-v2"
          element={
            <RequireAuth>
              <AccessControlSummaryV2Page />
            </RequireAuth>
          }
        />
        <Route
          path="reporting/access-control-summary"
          element={
            <RequireAuth>
              <AccessControlPage />
            </RequireAuth>
          }
        />
        <Route
          path="reporting/access-control-summary-v2"
          element={
            <RequireAuth>
              <AccessControlSummaryV2Page />
            </RequireAuth>
          }
        />
        <Route
          path="sales-attendance"
          element={
            <RequireAuth>
              <EventSalesAndAttendancePage />
            </RequireAuth>
          }
        />
        <Route
          path="comp-intelligence"
          element={
            <RequireAuth>
              <CompIntelligencePage />
            </RequireAuth>
          }
        />
        <Route
          path="ar-aging-summary"
          element={
            <RequireAuth>
              <ARAgingSummaryPage />
            </RequireAuth>
          }
        />
        <Route
          path="ar-aging-details"
          element={
            <RequireAuth>
              <ARAgingDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="time-stamp-report"
          element={
            <RequireAuth>
              <TimeStampReportPage />
            </RequireAuth>
          }
        />
        <Route
          path="events/create"
          element={
            <RequireAuth>
              <CreateEventPage />
            </RequireAuth>
          }
        />
        <Route
          path="ticket-exchange"
          element={
            <RequireAuth>
              <TicketExchangePage />
            </RequireAuth>
          }
        />
        <Route
          path="flex-packages"
          element={
            <RequireAuth>
              <FlexPacksPage />
            </RequireAuth>
          }
        />
        <Route
          path="flex-package/:uuid"
          element={
            <RequireAuth>
              <MyFlexPackPage />
            </RequireAuth>
          }
        >
          <Route index element={<FlexPackDashboardPage />} />
          <Route
            path="flex-package-details"
            element={<FlexPackDetailsPage />}
          />
          <Route
            path="assign-flex-packages"
            element={<AssignFlexPackagesPage />}
          />
          <Route
            path="flex-package-holders"
            element={<FlexPackHoldersPage />}
          />
        </Route>
        <Route
          path="season-packages"
          element={
            <RequireAuth>
              <SeasonPackagesPage />
            </RequireAuth>
          }
        ></Route>
        <Route
          path="access-passes"
          element={
            <RequireAuth>
              <AccessPassesPage />
            </RequireAuth>
          }
        ></Route>
        <Route
          path="access-pass-holders"
          element={
            <RequireAuth>
              <AccessPassHoldersReportPage />
            </RequireAuth>
          }
        />
        <Route
          path="group-purchases"
          element={
            <RequireAuth>
              <GroupPurchasesPage />
            </RequireAuth>
          }
        ></Route>
        <Route
          path="fulfillment"
          element={
            <RequireAuth>
              <FulfillmentBoardPage />
            </RequireAuth>
          }
        />
        <Route path="settings" element={<SettingsPage />}>
          <Route
            path="organization-information"
            element={<OrganizationInfoPage />}
          />
          <Route
            path="organization-settings"
            element={<OrganizationSettingsPage />}
          />
          <Route path="email-templates" element={<EmailTemplatesPage />} />
          <Route path="team-management" element={<TeamManagementPage />} />
          <Route path="security" element={<SecurityPage />} />
          {[
            'account-information',
            'account-information/payouts',
            'account-information/payouts/:id',
          ].map((path) => (
            <Route
              key={path}
              path={path}
              element={<AccountInformationPage />}
            />
          ))}
          <Route path="payouts" element={<PayoutsPage />} />
          <Route path="tax-status" element={<TaxStatusPage />} />
          <Route path="terminals" element={<TerminalsPage />} />
          <Route path="scanners" element={<ScannersPage />} />
          <Route path="custom-fees" element={<CustomFeesPage />} />
          <Route path="buyer-types" element={<BuyerTypesPage />} />
          <Route
            path="marketing-attribution"
            element={<MarketingTrackingPage />}
          />
          <Route path="marketplace" element={<MarketplacePage />}>
            <Route path="items" element={<MarketplaceItemsPage />} />
            <Route path="items/new" element={<MarketplaceItemFormPage />} />
            <Route
              path="items/:id/edit"
              element={<MarketplaceItemFormPage />}
            />
            <Route path="categories" element={<MarketplaceCategoriesPage />} />
            <Route path="modifiers" element={<MarketplaceModifiersPage />} />
            <Route path="locations" element={<MarketplaceLocationsPage />} />
            <Route path="orders" element={<MarketplaceOrdersPage />} />
            <Route
              path="import-export"
              element={<MarketplaceImportExportPage />}
            />
          </Route>
          <Route path="donations" element={<DonationsPage />} />
        </Route>
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="club-seats" element={<ClubSeatPage />} />
        <Route path="orders" element={<SearchOrdersPage />} />
        <Route path="deposits" element={<DepositsPage />} />
        <Route path="reporting" element={<ReportingPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="report-builder" element={<ReportBuilderPage />} />
        <Route
          path="promoter-sales-reports"
          element={<PromoterSalesReportsPage />}
        />
        <Route path="season-summary" element={<SeasonSummaryPage />} />
        <Route path="deferred-revenue" element={<DeferredRevenuePage />} />
        <Route
          path="flex-pack-deferred-revenue"
          element={<FlexPackDeferredRevenuePage />}
        />
        <Route path="scans-chart" element={<ScanChartPage />} />
        <Route path="ticket-matrix" element={<TicketMatrixPage />} />
        <Route path="assign-inventory" element={<AssignInventoryPage />} />
        <Route
          path="daily-tickets-count"
          element={<DailyTicketsCountReportPage />}
        />
        <Route path="settlement-report" element={<SettlementReportPage />} />
        <Route path="sales-summary-report" element={<SalesSummaryPage />} />
        <Route path="sales-velocity" element={<SalesVelocityPage />} />
        <Route
          path="pricing-level-performance"
          element={<PricingLevelPerformancePage />}
        />
        <Route
          path="attendance-intelligence"
          element={<AttendanceIntelligencePage />}
        />
        <Route
          path="geographic-sales-intelligence"
          element={<GeographicSalesIntelligencePage />}
        />
        <Route
          path="weather-event-analytics"
          element={<WeatherEventAnalyticsPage />}
        />
        <Route path="fnb-analytics" element={<FnbAnalyticsPage />} />
        <Route path="fnb-eod-report" element={<FnbEodReportPage />} />
        <Route path="revenue-insights" element={<RevenueInsightsPage />} />
        <Route path="insights-dashboard" element={<InsightsDashboardPage />} />
        <Route path="order-listings" element={<PaymentListingsV4Page />} />
        <Route path="season-report" element={<SeasonReportPage />} />
        <Route path="payouts-report" element={<PayoutsReportPage />} />
        <Route path="payouts-report/payouts" element={<PayoutsReportPage />} />
        <Route
          path="payouts-report/payouts/:id"
          element={<PayoutsReportPage />}
        />
        <Route
          path="payment-plans-report"
          element={<PaymentPlansReportPage />}
        />
        <Route
          path="payment-plans-report/payment-plans/:id"
          element={<PaymentPlansReportPage />}
        />
        <Route path="custom-fee-report" element={<CustomFeeReportPage />} />
        <Route path="henson-fund-report" element={<HensonFundReportPage />} />
        <Route
          path="payment-method-type-report"
          element={<PaymentMethodTypeReportPage />}
        />
        <Route path="packages-report" element={<PackagesReportPage />} />
        <Route
          path="flex-package-sales-summary"
          element={<FlexPackageSalesSummaryPage />}
        />
        <Route
          path="sales-receivables-by-category"
          element={<SalesReceivablesByCategoryPage />}
        />
        <Route path="buyer-types-report" element={<BuyerTypesReportPage />} />
        <Route path="aged-receivables" element={<AgedReceivablesPage />} />
        <Route path="user-balance-totals" element={<UserBalanceTotalsPage />} />
        <Route path="daily-settlement" element={<DailySettlementPage />} />
        <Route
          path="summary-by-payment-method"
          element={<SummaryByPaymentMethodPage />}
        />
        <Route
          path="accounting-dashboard"
          element={<AccountingDashboardPage />}
        />
        <Route path="accounting-report" element={<AccountingReportPage />} />
        <Route
          path="organization-dashboard"
          element={<OrganizationDashboardPage />}
        />
        <Route path="client-report" element={<ClientReportPage />} />
        <Route path="promo-codes" element={<PromoCodesPage />} />
        <Route path="promo-emails" element={<PromoEmailsPage />} />
        <Route path="fundraisers" element={<FundraisersPage />} />
        <Route
          path="yoy-difference-report"
          element={<YOYDifferenceReportPage />}
        />
      </Routes>
    </ScrollToTop>
  )
}

export default Router
